import { a as P, b as j, c as F, d as H, e as I, f as R, g as U, h as z, o as D, s as E, i as S, j as T } from "../../../floating-ui.react-CreHqeI3.js";
import { useState as W, useImperativeHandle as $, useMemo as q } from "react";
const G = (l) => {
  const {
    defaultOpen: i = !1,
    interaction: o,
    offset: r,
    onOpenChange: c,
    open: p,
    placement: d,
    viewportMargin: n,
    popoverRef: f,
    role: u,
    strategy: g,
    matchTriggerWidth: m = !1
  } = l, [h, O] = W(i), v = p ?? h, e = c ?? O;
  $(f, () => ({
    open: () => e(!0),
    close: () => e(!1)
  }));
  const t = P({
    middleware: [
      D(r),
      E({ padding: n }),
      S({ padding: n }),
      ...m ? [
        T({
          apply({ rects: y, elements: M }) {
            Object.assign(M.floating.style, {
              width: `${y.reference.width}px`
            });
          }
        })
      ] : []
    ],
    open: v,
    onOpenChange: e,
    placement: d,
    strategy: g,
    whileElementsMounted: z
  }), { context: s } = t, b = j(s, { enabled: o?.click ?? !1 }), w = F(s, { enabled: o?.hover ?? !1 }), C = H(s, { enabled: o?.focus ?? !1 }), k = I(s), x = R(s, { role: u }), a = U([b, k, w, C, x]);
  return q(
    () => ({
      setOpen: e,
      ...t,
      ...a
    }),
    [e, a, t]
  );
};
export {
  G as default
};
